import { AxiosInstance } from 'axios'
import { Slider } from '@/types/api/api-v3/slider'
import { Product } from '@/types/api/api-v3/product'
import {
  HttpStatusCode,
  NotFoundError,
  ServerError,
  Success,
} from '@/api/results'
import {
  Category,
  CategoryPage as OneCategory,
} from '@/types/api/api-v3/category'

export function createCategoryService({
  axios,
  sentry,
  city,
}: {
  axios: AxiosInstance
  sentry: any
  city: string
}) {
  return {
    async fetchMainSliders() {
      try {
        const response = await axios.get<Slider[]>(`/${city}/main/sliders/`)

        return new Success(response.data || [])
      } catch (error) {
        switch (error.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError('Страница не найдена. fetchMainSliders')
          default:
            sentry.captureException(error)
            return new ServerError('Что-то пошло не так')
        }
      }
    },
    async fetchSimpleCategories() {
      try {
        const response = await axios.get<Category[]>(`/${city}/categories/`)

        return new Success(response?.data || [])
      } catch (error) {
        switch (error.response?.status) {
          default:
            sentry.captureException(error)

            return new ServerError('Что-то пошло не так. fetchSimpleCategories')
        }
      }
    },
    async fetchOneCategory(categorySlug: string) {
      try {
        const { data } = await axios.get<OneCategory>(
          `/${city}/categories/${categorySlug}/`,
        )

        return new Success(data || [])
      } catch (error) {
        switch (error.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError('Категория не найдена')
          default:
            sentry.captureException(error)
            return new ServerError('Что-то пошло не так. fetchOneCategory')
        }
      }
    },
    async fetchOneProduct(productSlug: string) {
      try {
        const { data } = await axios.get<Product>(
          `/${city}/product/${productSlug}/`,
        )

        return new Success(data || [])
      } catch (error) {
        switch (error.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError('Продукт не найден')
          default:
            sentry.captureException(error)
            return new ServerError('Что-то пошло не так. fetchOneProduct')
        }
      }
    },
  }
}
